import { listAllocations, listEnrollments } from '@/lib/api'
import { useAsyncData } from '@/lib/useAsyncData'

export function LecturerCoursesPage() {
  const allocations = useAsyncData(listAllocations, [])
  const enrollments = useAsyncData(listEnrollments, [])

  return (
    <div className="space-y-6 p-8">
      <h1 className="text-2xl font-bold text-slate-800">My Courses</h1>
      {allocations.loading && <p className="text-sm text-slate-500">Loading…</p>}
      {allocations.error && (
        <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">{allocations.error}</p>
      )}
      <div className="grid gap-4 md:grid-cols-2">
        {(allocations.data || []).map((a) => {
          const count = (enrollments.data || []).filter((e) => e.course === a.course).length
          return (
            <article key={a.id} className="rounded-2xl border border-slate-100 bg-white p-5 shadow-sm">
              <p className="text-xs font-bold tracking-wider text-emerald-600 uppercase">
                {a.course_details.code}
              </p>
              <h2 className="mt-1 text-lg font-bold text-slate-800">{a.course_details.title}</h2>
              <p className="mt-2 text-xs text-slate-500">
                {a.semester_name} · {count} enrolled · {a.course_details.credits} credits
              </p>
            </article>
          )
        })}
      </div>
      {!allocations.loading && (allocations.data || []).length === 0 && (
        <p className="text-sm text-slate-500">No course allocations.</p>
      )}
    </div>
  )
}
